const TourActions = {
  SET_TOUR_PARAMS: 'TourActions.SET_TOUR_PARAMS',
};

export default TourActions;
